import { Container, ContainerModule } from 'inversify';
import React, {
  FC, memo, PropsWithChildren, useContext, useEffect, useMemo
} from 'react';

import { DIContext, DIContextProps } from '../context/di';

export interface DIContainerProviderProps extends PropsWithChildren {
  mainContainer?: Container;
  modules?: ContainerModule[];
}

export const DIContainerProvider: FC<DIContainerProviderProps> = memo(props => {
  const { children, modules, mainContainer } = props;
  const { mainContainer: mainContainerFromContext } = useContext(DIContext);

  const contextProps: DIContextProps = useMemo(() => (
    { mainContainer: mainContainerFromContext || mainContainer }
  ), []);

  useEffect(() => () => {
    if (mainContainerFromContext && modules) {
      mainContainerFromContext.load(...modules);
    }
  }, []);

  if (modules) {
    contextProps.mainContainer!.load(...modules);
  }

  return (
    <DIContext.Provider value={contextProps}>
      {children}
    </DIContext.Provider>
  );
});
